export const DrupalColors = {
  blue: "#35A1E3",
  lightBlue: "#aedaf5",
};
